import { render, staticRenderFns } from "./WhatsappOfficialReonboard.vue?vue&type=template&id=6d29028f&scoped=true&"
import script from "./WhatsappOfficialReonboard.vue?vue&type=script&lang=js&"
export * from "./WhatsappOfficialReonboard.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappOfficialReonboard.vue?vue&type=style&index=0&id=6d29028f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d29028f",
  null
  
)

export default component.exports